/* @flow */
import cx from 'classnames';
import * as React from 'react';

import { CTX_ANNOUNCEMENT_STREAM, StreamContext } from 'chat/components/Stream';
import CurrentUser from 'auth/CurrentUser';
import ChatMessageItem from './ChatMessageItem.jsx';
import AnnouncementMessageItem from './AnnouncementMessageItem.jsx';
import MessageViewTracker from 'components/MessageViewTracker.jsx';

import './styles/MessageItems.scss';

type Props = {
  items: *,
  uuid: string,
};

class MessageItems extends React.Component<Props, void> {
  isAuthor() {
    return CurrentUser.getUserUuid() === this.props.items[0].item.sender.uuid;
  }

  getSenderName() {
    return this.props.items[0].item.sender.name;
  }

  renderContent() {
    const { items } = this.props;

    const messageItems = items.map(item => {
      const isLast = item === items[items.length - 1];
      const isBroadcast =
        !!item.item.group || item.item.type === 'broadcast' || item.item.type === 'message';
      const isAuthor = CurrentUser.getUserUuid() === item.item.sender.uuid;

      return (
        <StreamContext.Consumer key={item.key}>
          {streamContext => {
            const canViewDeliveryInformation =
              (isAuthor && isBroadcast) || streamContext === CTX_ANNOUNCEMENT_STREAM;
            return (
              <MessageViewTracker
                messageUuid={item.item.uuid}
                isBroadcast={isBroadcast}
                chatUuid={this.props.uuid}
                canViewDeliveryInformation={canViewDeliveryInformation}>
                {isBroadcast ? (
                  <AnnouncementMessageItem
                    item={item}
                    streamUuid={this.props.uuid}
                    isLastItemOfChunk={isLast}
                    canViewDeliveryInformation={canViewDeliveryInformation}
                  />
                ) : (
                  <ChatMessageItem
                    item={item}
                    streamUuid={this.props.uuid}
                    isLastItemOfChunk={isLast}
                  />
                )}
              </MessageViewTracker>
            );
          }}
        </StreamContext.Consumer>
      );
    });

    if (this.isAuthor()) {
      return <div className="MessageItems-content">{messageItems}</div>;
    }

    return (
      <div className="MessageItems-messageGroup">
        <div className="MessageItems-contentWrap">
          <span className="MessageItems-name">{this.getSenderName()}</span>
          <div className="MessageItems-content">{messageItems}</div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <li
        className={cx('MessageItems', {
          'MessageItems-self': this.isAuthor(),
          'MessageItems-other': !this.isAuthor(),
        })}>
        {this.renderContent()}
      </li>
    );
  }
}

export default MessageItems;
